import './App.css';
import Home from './components/Home/Home';
import 'bootstrap/dist/css/bootstrap.min.css'

function App() {
  return (
    <div className="gradient-custom">
      <Home/>
    </div>
  );
}

export default App;
